import { pressLogos, pressMentions } from '../../data/content';

/** Of er pers is om te tonen. */
export const hasPress = () => pressLogos.length > 0 || pressMentions.length > 0;

/**
 * "Aanbevolen in": logo's en namen van media, als regel onder haar verhaal op Over. Geen eigen
 * vlak: pers is het bewijs bij het verhaal. Zonder vermeldingen niets.
 */
export function PressStrip({
  className = ''
}: {
  className?: string;
}) {
  if (!hasPress()) return null;
  return <div className={`flex flex-col items-center gap-6 border-t border-ink/15 pt-10 lg:flex-row lg:justify-between lg:gap-12 ${className}`} data-id="element-8764" data-mp="15shd6he3y31c">
      <p className="whitespace-nowrap text-[14px] text-muted" data-id="element-8765" data-mp="1fp2jr75rzm7a">Aanbevolen in</p>
      <ul className="flex flex-wrap items-center justify-center gap-x-10 gap-y-5 sm:gap-x-14" data-id="element-8766" data-mp="1fr6xshxe21la">
        {pressLogos.map(logo => <li key={logo.name} data-id="element-8767" data-mp="2r4r9256i4xb9">
            <img src={logo.image} alt={logo.name} loading="lazy" className={`${logo.size === 'lg' ? 'h-10 sm:h-12' : 'h-6 sm:h-7'} w-auto opacity-80 mix-blend-multiply`} data-id="element-8768" data-mp="2r3g3q0xerhi1" />
          </li>)}
        {pressMentions.map(name => <li key={name} className="type-name text-muted" data-id="element-8769" data-mp="cc5oz5p2d6rm">
            {name}
          </li>)}
      </ul>
    </div>;
}